import Vue from 'vue'
import { ACCESS_TOKEN, APPLICATION_LOG, ENTERPRISE, OPERATOR, RECENT_ROUTES, WAREHOUSE } from '@/store/mutation-types'
import { findEnum, findOne } from '@/api/Api'
import { Identifier } from '@/api/dto/Identifier'

const dictionaryPrefix = 'DICTIONARY_'
const baseDataPrefix = 'BASE_DATA_'
const enumPrefix = 'ENUM_'
const vueLsPrefix = 'pro__'

export function timeFix() {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function welcome() {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader(callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function() {
  }
  window.addEventListener(
    'scroll',
    event => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate(id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}

export function clearVue() {
  Vue.ls.remove(ACCESS_TOKEN)
  Vue.ls.remove(OPERATOR)
  Vue.ls.remove(ENTERPRISE)
  Vue.ls.remove(WAREHOUSE)
  Vue.ls.remove(APPLICATION_LOG)
  Vue.ls.remove(RECENT_ROUTES)
}

export function getUser() {
  return Vue.ls.get(OPERATOR)
}

export function getEnterprise() {
  return Vue.ls.get(ENTERPRISE)
}

export function getWarehouse() {
  return Vue.ls.get(WAREHOUSE)
}

//region 数量处理
export function isNumber(source) {
  if (isNaN(source)) {
    return Vue.prototype.$warning({
      title: '警告',
      content: '请输入数字'
    })
  }
}

export function isNew(data) {
  if (data === null || data === undefined || data['id'] === null || data['id'] === undefined) {
    return true
  }
  return false
}

export function isLegal(data) {
  if (data === null || data === undefined || data === '') {
    return false
  }
  return true
}

export function onQuantityChanged(source, factor, target) {
  isNumber(source)
  target.case = Math.floor(source / factor)
  target.each = source - target.case * factor
}

export function onCaseChanged(source, factor, target) {
  isNumber(source)
  target.quantity = source * factor
  target.each = 0
}

export function onEachChanged(source, factor, target) {
  isNumber(source)
  target.quantity = source
  target.case = Math.floor(target.quantity / factor)
}

export function onInputChange(type, field, value) {
  type[field] = value ? new Identifier({ id: value.id, no: value.no, name: value.name }) : new Identifier()
}

export function getStrings(arr, fieldName) {
  let fieldValue = ''
  if (arr) {
    const arr1 = []
    arr.forEach(item => {
      arr1.push(item[fieldName])
    })
    if (arr1.length > 0) {
      fieldValue = arr1.join(',')
    }
  }
  return fieldValue
}

export function truncateString(str, maxLength, useEllipsis = true) {
  if (str === null || str === undefined) {
    return ''
  }
  if (str.length > maxLength) {
    return str.slice(0, maxLength - (useEllipsis ? 3 : 0)) + (useEllipsis ? '...' : '')
  }
  return str
}

export function convert(value, data, fieldValue, fieldName) {
  if (value === null || value === undefined) {
    return value
  }
  if (data instanceof Array && data.length > 0) {
    let field = data.find(item => item[fieldValue] === value)
    return field ? field[fieldName] : value
  }
  return value
}

export function getValue(key) {
  const papameter = this.$route.params[key]
}

export function getDictionaries(no) {
  return new Promise((resolve) => {
    if (no && no.length > 0) {
      let dictionaries = Vue.ls.get(dictionaryPrefix + no)
      if (dictionaries && dictionaries.length > 0) {
        resolve(dictionaries)
      } else {
        findOne('fieldFactory', { no: no }).then(res => {
          if (res.success && res.result && res.result.dictionaries && res.result.dictionaries.length > 0) {
            dictionaries = getOptions(res.result.dictionaries)
            Vue.ls.set(dictionaryPrefix + no, dictionaries)
            resolve(dictionaries)
          } else {
            resolve([])
          }
        })
      }
    } else {
      resolve([])
    }
  })
}

export function getEnums(name) {
  return new Promise((resolve) => {
    if (name && name.length > 0) {
      let enums = Vue.ls.get(enumPrefix + name)
      if (enums && enums.length > 0) {
        resolve(enums)
      } else {
        findEnum(name).then(res => {
          if (res.success && res.result && res.result.length > 0) {
            enums = res.result.map(item => {
              return { value: item.ordinal, label: item.name }
            })
            Vue.ls.set(enumPrefix + name, enums)
            resolve(enums)
          } else {
            resolve([])
          }
        })
      }
    } else {
      resolve([])
    }
  })
}

export function getOptions(result) {
  return result.map(item => {
    return { value: item.id, label: item.name, no: item.no, ordinal: item.ordinal }
  })
}

export function clearAllCache() {
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith(vueLsPrefix)) {
      let actualKey = key.substring(vueLsPrefix.length)
      if (actualKey.startsWith(dictionaryPrefix) || actualKey.startsWith(enumPrefix) || actualKey.startsWith(baseDataPrefix)) {
        console.log('clear cache', actualKey)
        localStorage.removeItem(key)
      }
    }
  })
}

export function formatSelect({ itemValue }, options) {
  const option = options.find(item => item.value === itemValue)
  return option ? option.label : itemValue
}

export function formatBankCard({ itemValue }) {
  return XEUtils.commafy(XEUtils.toValueString(itemValue), { spaceNumber: 4, separator: ' ' })
}

export function formatAmount({ itemValue }) {
  return XEUtils.commafy(XEUtils.toNumber(itemValue), { digits: 2 })
}